import axios from "axios";
import "../../CSS/PaymentModal.css";
import { useState } from "react";
import useGetEmployees from "../../API/useGetEmployees";
import { APP_SERVICES_URL } from "../../Constant/constant";
import userSession from "../../Constant/auth";
import SimpleBackdrop from "../SimpleBackdrop";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import moment from "moment";
import { Modal } from "react-bootstrap";
import NotificationModal from "./NotificationModal";

const PaymentModal = ({
  show,
  onHide,
  setSuccess,
  settitleData,
  setBodyData,
}) => {
  const { CustID, authHeader, site } = userSession;
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [licensePlate, setLicensePlate] = useState("");
  const [pendingPayments, setPendingPayments] = useState([]);
  const [receiptNumber, setReceiptNumber] = useState(""); // State for reference number
  const [selectedEmployee, setSelectedEmployee] = useState(""); // State for selected employee
  const [validationMessage, setValidationMessage] = useState("");
  const [successPaymentCheck, setSuccessPaymentCheck] = useState(false);
  const [referenceNumberCheck, setReferenceNumberCheck] = useState(false);

  const handlePaymentSuccess = () => {
    setSuccess((prevState) => !prevState);
  };
  const { employees } = useGetEmployees();
  // Filter employees with active=true
  const activeEmployees = employees.filter(
    (employee) => employee.active === true
  );
  const formatDateTime = (dateTimeString) => {
    // Create a moment object from the input date-time string
    const momentDateTime = moment(dateTimeString, "YYYY-MM-DDTHH:mm:ss.SSS");

    // Format the moment object to 12-hour format with AM/PM
    const formattedTime = momentDateTime.format("h:mm A"); // 12-hour format with AM/PM

    // Format the date in the desired format (DD/MM/YYYY)
    const localDateString = momentDateTime.format("DD/MM/YYYY");

    return <div>{`${formattedTime.toUpperCase()} ${localDateString}`}</div>;
  };
  const fetchPendingPayments = async (licensePlate) => {
    try {
      setSuccessPaymentCheck(false);
      // Clear pendingPayments state before fetching new data
      setPendingPayments([]);

      // Convert licensePlate to uppercase
      const upperCaseLicensePlate = licensePlate.toUpperCase();

      // Use the uppercase license plate for the API request
      const apiUrl = `${APP_SERVICES_URL}/senapi/${CustID}/pendingPayments?ocr=${upperCaseLicensePlate}&siteName=${site.name}`;

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: authHeader,
          "Cache-Control": "no-cache",
        },
      });

      if (response.status === 200) {
        const data = response.data;
        if (data.length === 0) {
          setSuccessPaymentCheck(true);
        }
        setPendingPayments(data);
      } else {
        console.error(
          "Error fetching pending payments. HTTP status:",
          response.status
        );
        // Handle non-200 status codes here if needed
        // You can log or display an appropriate message based on the status code.
        throw new Error("Failed to fetch pending payments"); // Throw an error to handle it in the catch block
      }
    } catch (error) {
      console.error("Error fetching pending payments:", error);
      console.error("API NOT CALLED:", error);
    }
  };
  const handleTakePaymentClick = (paymentData) => {
    setCurrentPage(2);
    // Filter the pendingPayment state to match only the selected payment data
    const filteredPayments = pendingPayments.filter((payment) => {
      // Compare each payment with the selected payment data
      return (
        payment.alertID === paymentData.alertID
        // payment.id === paymentData.id &&
        // payment.amount === paymentData.amount
        // Add other properties comparison as needed
      );
    });
    // Check if any matching payments were found
    if (filteredPayments.length > 0) {
      // Set the filtered payments as the new state
      setPendingPayments(filteredPayments);
    } else {
      // Handle the case where no matching payments were found
      console.error("No matching payments found.");
      // Optionally, you can provide feedback to the user or take other actions.
    }
    // Open the modal
  };
  const handleInputChange = (e) => {
    setLicensePlate(e.target.value);
  };
  const handleSubmitRego = (e) => {
    e.preventDefault();
    fetchPendingPayments(licensePlate);
  };

  const validateFields = () => {
    if (!receiptNumber) {
      // setValidationMessage("Reference");
      setReferenceNumberCheck(true);
      return false;
    }
    if (!selectedEmployee) {
      setValidationMessage("Employee");
      return false;
    }
    // Clear validation message if both fields are valid
    setValidationMessage("");
    return true;
  };

  const handlePaymentClick = async () => {
    // Validate if referenceNumber and selectedEmployee are not empty
    const alertID = pendingPayments[0].alertID;
    const amount = pendingPayments[0].amount;
    const detectedTime = pendingPayments[0].alertTimestamp;

    if (!alertID) {
      NotificationManager.error("Alert ID is missing", "Error", 3000);
      return;
    }

    if (!amount) {
      NotificationManager.error("Amount is missing", "Error", 3000);
      return;
    }

    try {
      setSuccessPaymentCheck(false);
      setIsLoading(true);
      const utcTime = moment.utc(detectedTime); // Assuming the UTC time is '2024-04-30T05:10:00'
      const localTime = utcTime.local(); // Convert to local time zone
      const localTimeWithOffset = localTime.format("YYYY-MM-DDTHH:mm:ss.SSS"); // Use 'T' to separate the date and time, and omit the space
      // Define the request body
      const requestBody = {
        alertID,
        siteName: site.name,
        timestamp: localTimeWithOffset, // Current timestamp
        employeeName: selectedEmployee,
        fees: "0",
        amount,
        receiptNumber,
      };

      // Make the POST request
      const response = await axios.post(
        `${APP_SERVICES_URL}/senapi/${CustID}/payment`,
        requestBody,
        {
          headers: {
            Authorization: authHeader, // Replace with your basic auth credentials
            "Content-Type": "application/json",
          },
        }
      );

      setIsLoading(false);

      if (response.status === 200) {
        // Reset the state values
        setIsLoading(false);
        closeModal();
        handlePaymentSuccess();
        settitleData("Payment confirmed!");
        setBodyData("The incident payment has been logged successfully.");
        setReceiptNumber("");
        setSelectedEmployee("");
        setPendingPayments([]);
        setLicensePlate("");
      } else {
        console.error("Payment failed. HTTP status:", response.status);
        setIsLoading(false);
        handlePaymentFailureNotification();
      }
    } catch (error) {
      console.error("Error making payment:", error);
      setIsLoading(false);
    }
  };

  // Function to handle payment failure notification
  const handlePaymentFailureNotification = () => {
    NotificationManager.error(
      <div className="showNormalFont">
        Payment failed. Please try again later
      </div>,
      <div className="showNormalFont">Error</div>,
      3000
    );
  };
  const closeModal = () => {
    onHide();
    setCurrentPage(1);
    setLicensePlate("");
    setPendingPayments([]);
    setSelectedEmployee("");
    setReceiptNumber("");
  };

  const handleCloseSuccessPaymentModal = () => {
    setSuccessPaymentCheck(false);
  };
  const handleCloseReferenceNumberModal = () => {
    setReferenceNumberCheck(false);
  };

  return (
    <Modal show={show} onHide={onHide} fullscreen>
      <NotificationModal
        label={"successPaymentCheck"}
        show={successPaymentCheck}
        handleClose={handleCloseSuccessPaymentModal}
        title="No payments due!"
        body="There are no outstanding payments at your site for this registration number."
      />
      <NotificationModal
        label={"referenceNumberCheck"}
        show={referenceNumberCheck}
        handleClose={handleCloseReferenceNumberModal}
        title="Reference Number?"
        body="Please enter a reference number for this payment."
      />
      <SimpleBackdrop open={isLoading} onClose={() => setIsLoading(false)} />
      <NotificationContainer />
      <div className="modal-dialog modal-dialog-centered modal-fullscreen modal-dialog-scrollable">
        <div
          className="modal-content"
          style={{ backgroundColor: "#212529", color: "#FFFFFF" }}
        >
          <div className="modal-header">
            <h5 id="DriveOff-title">Take Payment</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <div
              className="container-fluid showNormalFont"
              style={{ marginLeft: "-5px" }}
            >
              {currentPage === 1 && (
                <form onSubmit={handleSubmitRego}>
                  <div className="container-fluid">
                    <h5 style={{ color: "#fff" }}>Search Payments</h5>
                    <p style={{ color: "#ADB5BD" }}>
                      Enter the customer registration number below to search for
                      outstanding payments at your site.
                    </p>
                    <label
                      style={{ color: "#ADB5BD" }}
                      htmlFor="payment-rego-input"
                      className="form-label"
                    >
                      Registration Number
                    </label>
                    <div className="input-group-payment-modal mb-3">
                      <input
                        type="text"
                        className="form-control"
                        autoFocus
                        id="payment-rego-input"
                        aria-describedby="payment-rego-help"
                        required
                        data-lpignore="true"
                        value={licensePlate.toUpperCase()}
                        autoComplete="off"
                        onChange={handleInputChange}
                        onInput={(e) => {
                          // Remove spaces from the input value
                          let newValue = e.target.value.replace(/\s/g, "");
                          // Limit the input to 10 characters
                          newValue = newValue.slice(0, 11);
                          // Allow only alphanumeric characters
                          newValue = newValue.replace(/[^A-Za-z0-9]/g, "");
                          // Update the input value
                          e.target.value = newValue.toUpperCase();
                        }}
                      />
                      <button
                        id="btn-payment-search"
                        className="btn btn-outline-primary "
                        type="submit"
                      >
                        Search Payments
                      </button>
                    </div>
                    <table id="fuel-cost-table">
                      <thead className="table-header">
                        <tr className="table-row">
                          <th className="table-header-cell">Date</th>
                          <th className="table-header-cell">Fuel Cost</th>
                          <th className="table-header-cell">Fuel Litres</th>
                          <th className="table-header-cell">Action</th>
                        </tr>
                      </thead>
                      <tbody className="table-body">
                        {pendingPayments.length !== 0 &&
                          pendingPayments.map((payment) => (
                            <tr key={payment.alertID} className="table-row">
                              <td className="table-cell">
                                {formatDateTime(payment.alertTimestamp)}
                              </td>
                              <td className="table-cell">${payment.amount}</td>
                              <td className="table-cell">
                                {payment.fuelLitres}
                              </td>
                              <td className="table-cell">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() =>
                                    handleTakePaymentClick(payment)
                                  }
                                >
                                  Take Payment
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </form>
              )}
              {currentPage === 2 && (
                <div
                  className="container-fluid showNormalFont"
                  style={{ marginLeft: "-5px" }}
                >
                  <h5 style={{ color: "#fff" }}>Confirm Payments</h5>
                  <p style={{ color: "#ADB5BD" }}>
                    Charge the customer according to the below incident details
                  </p>
                  <table id="fuel-cost-table">
                    <thead className="table-header">
                      <tr className="table-row">
                        <th className="table-header-cell">Date</th>
                        <th className="table-header-cell">Fuel Cost</th>
                        <th className="table-header-cell">Fuel Litres</th>
                        <th className="table-header-cell">Amount Charged</th>
                      </tr>
                    </thead>
                    <tbody className="table-body">
                      {pendingPayments.length !== 0 &&
                        pendingPayments.map((payment) => (
                          <tr key={payment.alertID} className="table-row">
                            <td className="table-cell">
                              {formatDateTime(payment.alertTimestamp)}
                            </td>
                            <td className="table-cell">${payment.amount}</td>
                            <td className="table-cell">{payment.fuelLitres}</td>
                            <td className="table-cell">${payment.amount}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <div className="form-group p-2">
                    <label
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        paddingBottom: '5px',
                        // color: "#ADB5BD",
                        color:
                          validationMessage === "Reference" ? "red" : "#ADB5BD",
                      }}
                    >
                      Payment Reference
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={receiptNumber}
                      autoFocus
                      maxLength={15}
                      onChange={(e) => {
                        let inputText = e.target.value;

                        // Remove non-alphanumeric characters and convert to uppercase
                        inputText = inputText
                          .replace(/[^A-Za-z0-9]/g, "")
                          .toUpperCase();

                        // Update state with formatted input
                        setReceiptNumber(inputText);
                      }}
                      style={{
                        backgroundColor: "#212529",
                        color:
                          validationMessage === "Reference" ? "red" : "#ADB5BD",
                        borderColor: "#495057",
                        border: "1px solid #495057",
                        height: "2.3rem",
                        padding: "6px 12px",
                      }}
                      aria-label="Medium input example"
                      aria-describedby="inputGroup-sizing-default"
                      placeholder="Enter reference number..."
                    />
                  </div>
                  <div className=" p-2">
                    <label
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        paddingBottom: '5px',
                        color:
                          validationMessage === "Employee" ? "red" : "#ADB5BD",
                      }}
                    >
                      Employee
                    </label>
                    <br />
                    <select
                      style={{
                        width: '100%',
                        backgroundColor: "#212529",
                        color:
                          validationMessage === "Employee" ? "red" : "#ADB5BD",
                        borderColor: "#495057",
                        border: "1px solid #495057",
                        height: "2.3rem",
                        padding: "6px 12px",
                      }}
                      value={selectedEmployee || ""}
                      onChange={(e) => setSelectedEmployee(e.target.value)}
                      name="employee"
                      className="col-6"
                      required
                    >
                      <option value="">Select an employee</option>
                      {activeEmployees.map((employee, index) => (
                        <option key={index} value={employee.name}>
                          {employee.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer d-flex showNormalFont">
            <button
              className="btn btn-secondary me-2 w-25 custom-btn-payment"
              onClick={closeModal}
            >
              Close
            </button>
            {currentPage === 2 && (
              <>
                <button
                  className="btn btn-primary me-2 w-25 custom-btn-payment"
                  onClick={() => setCurrentPage(1)}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary me-2 w-25 custom-btn-payment"
                  onClick={() => {
                    if (validateFields()) {
                      handlePaymentClick();
                    }
                  }}
                >
                  Take Payment
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentModal;
